/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Machine_Id_LabelInputs */

const en_login_offline_machine_id_label = /** @type {(inputs: Login_Offline_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine ID`)
};

const fr_login_offline_machine_id_label = /** @type {(inputs: Login_Offline_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de Machine`)
};

const de_login_offline_machine_id_label = /** @type {(inputs: Login_Offline_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maschinen-ID`)
};

const it_login_offline_machine_id_label = /** @type {(inputs: Login_Offline_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID macchina`)
};

const ru_login_offline_machine_id_label = /** @type {(inputs: Login_Offline_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор машины`)
};

const es_login_offline_machine_id_label = /** @type {(inputs: Login_Offline_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación de la máquina`)
};

const zh_cn2_login_offline_machine_id_label = /** @type {(inputs: Login_Offline_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机器 ID`)
};

const ja_login_offline_machine_id_label = /** @type {(inputs: Login_Offline_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マシンID`)
};

const hi_login_offline_machine_id_label = /** @type {(inputs: Login_Offline_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मशीन आईडी`)
};

const pt_pt2_login_offline_machine_id_label = /** @type {(inputs: Login_Offline_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da máquina`)
};

/**
* | output |
* | --- |
* | "Machine ID" |
*
* @param {Login_Offline_Machine_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_machine_id_label = /** @type {((inputs?: Login_Offline_Machine_Id_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Machine_Id_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_machine_id_label(inputs)
	if (locale === "de") return de_login_offline_machine_id_label(inputs)
	if (locale === "it") return it_login_offline_machine_id_label(inputs)
	if (locale === "ru") return ru_login_offline_machine_id_label(inputs)
	if (locale === "es") return es_login_offline_machine_id_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_machine_id_label(inputs)
	if (locale === "ja") return ja_login_offline_machine_id_label(inputs)
	if (locale === "hi") return hi_login_offline_machine_id_label(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_machine_id_label(inputs)
	return en_login_offline_machine_id_label(inputs)
});